import {
  ACTIONS_FOR_SUPPORT_NAMES,
  LEGAL_FRAMEWORK_AND_RISKS_NAMES,
  LIST_OF_RISKS_NAMES,
} from 'components/BusinessToolForm/Sections/LegalFrameworkAndRisks/utils/form';

const ACTIONS_INSTRUCTIONS = {
  [ACTIONS_FOR_SUPPORT_NAMES.ACTION]: {
    name: 'Etapa',
    instruction:
      'Enumere todos los procedimientos legales obligatorios aplicables a las operaciones de la empresa. Identifique los procesos, trámites o requisitos legales esenciales para cumplir con la normativa vigente.',
    exampleOne: 'Obtener la certificación de seguridad para maquinaria agrícola del USDA',
    exampleTwo: 'Registrar la marca comercial',
  },

  [ACTIONS_FOR_SUPPORT_NAMES.START_DATE]: {
    name: 'Plazos',
    instruction: 'Indique el estado actual de cada procedimiento y el plazo previsto para su finalización.',
    exampleOne: 'Mayo de 2024',
    exampleTwo: '',
  },

  [ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE]: {
    name: 'Plazos',
    instruction: 'Indique el estado actual de cada procedimiento y el plazo previsto para su finalización.',
    exampleOne: 'Completado',
    exampleTwo: 'Agosto de 2024',
  },
};

const RISKS_INSTRUCTIONS = {
  [LIST_OF_RISKS_NAMES.NAME]: {
    name: 'Nombre del riesgo',
    instruction:
      'Identifique e indique claramente el nombre del riesgo. Asegúrese de que sea específico y pertinente al contexto, utilizando una terminología que describa con precisión la naturaleza del riesgo.',
    exampleOne: 'Fluctuación de los precios de las materias primas',
    exampleTwo: 'Fluctuación de los tipos de cambio',
  },

  [LIST_OF_RISKS_NAMES.GROUP]: {
    name: 'Categoría del riesgo',
    instruction:
      'Indique de forma concisa la categoría del riesgo, especificando si se trata de riesgos económicos, organizativos, de mercado, productivos y técnicos, legales u otros.',
    exampleOne: 'Riesgos económicos',
    exampleTwo: 'Riesgos económicos',
  },

  [LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT]: {
    name: 'Impacto negativo',
    instruction:
      'Describa los efectos adversos de los riesgos, destacando las posibles pérdidas, interrupciones y daños a la reputación o a las operaciones de la empresa.',
    exampleOne:
      'La incertidumbre en la demanda de maquinaria agrícola puede afectar los ingresos y la rentabilidad de Agrotech debido a las fluctuaciones en los precios de las materias primas. El aumento de los precios puede desincentivar la inversión de los agricultores, mientras que la caída de los precios puede reducir los márgenes y el volumen de ventas de la empresa.',
    exampleTwo:
      'Las fluctuaciones de los tipos de cambio afectan el coste de importación de las materias primas y los ingresos por exportaciones de la empresa. Los tipos de cambio desfavorables incrementan los costes de producción y reducen la rentabilidad, mientras que los favorables pueden mejorar la competitividad, aunque también influyen en la estrategia de precios.',
  },

  [LIST_OF_RISKS_NAMES.PREVENTION_MEASURES]: {
    name: 'Medidas de prevención',
    instruction:
      'Comience con una visión general de las medidas específicas que el proyecto ha implementado para mitigar los riesgos identificados. Describa en detalle las acciones preventivas adoptadas para cada riesgo, como estrategias de diversificación, contratación de seguros, creación de fondos de contingencia o establecimiento de alianzas estratégicas.',
    exampleOne:
      'La empresa puede diversificar su cartera de productos, invertir en investigación para desarrollar procesos de fabricación más eficientes en costes, establecer contratos de suministro a largo plazo e implementar estrategias de precios flexibles.',
    exampleTwo:
      'La empresa puede utilizar instrumentos financieros de cobertura, diversificar su base de clientes entre distintas regiones, localizar parte de la producción para reducir la dependencia de las importaciones y negociar contratos a largo plazo denominados en monedas estables.',
  },
};

export const LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS = {
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.GENERAL_LAWS]: {
    name: 'Leyes y normativas generales',
    instruction:
      'Identifique la jurisdicción en la que opera la empresa y enumere las leyes y normativas que regulan su actividad. La lista puede incluir legislación mercantil, laboral y tributaria. Cite las leyes y disposiciones aplicables para demostrar el cumplimiento normativo y garantizar el desarrollo legal de las operaciones dentro de la jurisdicción correspondiente.',
    exampleOne:
      'La empresa opera en los Estados Unidos y está sujeta a diversas leyes y normativas, entre ellas el Internal Revenue Code en materia fiscal, la Fair Labor Standards Act en materia laboral y la Securities Act de 1933 en materia de gobierno corporativo.',
    exampleTwo:
      'La empresa opera en la jurisdicción del estado de California (Estados Unidos). Su actividad está regulada por el California Corporations Code, el California Labor Code y el California Revenue and Taxation Code. El cumplimiento de estas normas garantiza el desarrollo legal de sus operaciones.',
  },

  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.INDUSTRY_REQUIREMENTS]: {
    name: 'Requisitos específicos del sector',
    instruction:
      'Describa la normativa específica del sector que debe cumplir la empresa. Indique las licencias, certificaciones o permisos necesarios para operar conforme a la legislación aplicable. Asegúrese de que la descripción sea clara y precisa.',
    exampleOne:
      'La empresa cumple con la normativa específica del sector, incluida la Agricultural Improvement Act de 2018 (Farm Bill), aplicable al ámbito agrícola. Además, dispone de certificaciones ISO 9001, del Certificado de Cumplimiento de Normas sobre Emisiones y de la Certificación de Seguridad para Maquinaria Agrícola del USDA.',
    exampleTwo:
      'La empresa debe cumplir con la normativa específica del sector de los servicios lingüísticos, como la Translation and Interpreting Services Act. El cumplimiento requiere la obtención de licencias emitidas por la American Translators Association y la International Association of Professional Translators and Interpreters.',
  },

  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LEGAL_REQUIREMENTS]: {
    name: 'Cumplimiento de los requisitos legales',
    instruction:
      'Evalúe el nivel de cumplimiento de la empresa respecto a los requisitos legales necesarios para desarrollar su actividad. Identifique posibles carencias o incumplimientos y proponga un plan de acción para lograr el pleno cumplimiento de la normativa aplicable.',
    exampleOne:
      'Actualmente, la empresa cumple con los requisitos legales aplicables. Para reforzar este cumplimiento, está tramitando la Certificación de Seguridad para Maquinaria Agrícola del USDA, habiendo presentado ya toda la documentación necesaria para su aprobación por parte del organismo certificador de los Estados Unidos.',
    exampleTwo:
      'La empresa cumple con todos los requisitos legales para desarrollar su actividad, incluidos los relacionados con los servicios lingüísticos, las licencias, las certificaciones y los permisos exigidos en las jurisdicciones correspondientes.',
  },

  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_ACTIONS]: ACTIONS_INSTRUCTIONS,
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_RISKS]: RISKS_INSTRUCTIONS,
};
